/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from '../../../../components/Containers/ArgosFlexbox';
import {ReportsTable} from '../common/ReportsTable';


/**
 * This tab allows user to create, update, and view the World Model Solution
 * Requirement reports for the ADAS Program.
 */
export const WorldModelSolutionRequirements = () => {
  return (
    <ArgosFlexbox vertical style={{height: '100%', width: '100%'}}>
      <ReportsTable />
    </ArgosFlexbox>
  )
}
